import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import LoomBoard from "@/components/LoomBoard";
import YarnsExplainer from "@/components/YarnsExplainer";
import HowItWorks from "@/components/HowItWorks";
import SandrineIntro from "@/components/SandrineIntro";
import Footer from "@/components/Footer";
import { useSavedThreads } from "@/lib/hooks";

function Home() {
  const { saved, remove } = useSavedThreads();
  return (
    <main className="relative" data-testid="loom-landing-page">
      <Header />
      <Hero />
      <LoomBoard saved={saved} onRemove={remove} />
      <YarnsExplainer />
      <HowItWorks />
      <SandrineIntro />
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1a1a1a",
            color: "#fdfaf5",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: "Rubik, sans-serif",
          },
        }}
      />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
